export default __webpack_public_path__ + "static/media/Vehicle Ramp.8a1365d9.jpg";